import { Lozenge } from 'shared/lozenge/Lozenge';
import { tokens } from 'styles/tokens';

export type SettingEnabledLozengeProps = {
    enabled: boolean;
};

export function SettingEnabledLozenge({ enabled }: SettingEnabledLozengeProps) {
    return (
        <Lozenge
            backgroundColor={
                enabled ? tokens.lozenge.greenBackground : tokens.lozenge.grey4Background
            }
            color={tokens.text.onColor}
        >
            {enabled ? 'ENABLED' : 'DISABLED'}
        </Lozenge>
    );
}
